import { render, staticRenderFns } from "./ExcelInvoiceReceiver.vue?vue&type=template&id=0c2b7aa0&"
import script from "./ExcelInvoiceReceiver.vue?vue&type=script&lang=js&"
export * from "./ExcelInvoiceReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports